import React, { useState } from "react";
import Shell from "@/components/Shell";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    if (next !== confirm) { toast.error("Passwords do not match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated successfully");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setSaving(false); }
  };

  return (
    <Shell title="Change Password" subtitle="Update your account password.">
      <form onSubmit={submit} className="max-w-md">
        <Card className="p-6 border-zinc-200 shadow-none rounded-md bg-white">
          <div className="flex items-center gap-2 mb-5">
            <KeyRound size={16} strokeWidth={1.5} className="text-zinc-500" />
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">Account security</div>
          </div>
          <div className="space-y-4">
            <div>
              <Label className="font-semibold">Current password</Label>
              <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required autoComplete="current-password" data-testid="cp-current" />
            </div>
            <div>
              <Label className="font-semibold">New password</Label>
              <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={6} autoComplete="new-password" data-testid="cp-new" />
              <div className="text-xs text-zinc-500 mt-1">Minimum 6 characters.</div>
            </div>
            <div>
              <Label className="font-semibold">Confirm new password</Label>
              <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required autoComplete="new-password" data-testid="cp-confirm" />
            </div>
          </div>
          <div className="mt-6 flex justify-end">
            <Button type="submit" disabled={saving} className="bg-blue-700 hover:bg-blue-800 text-white" data-testid="cp-submit">
              {saving ? "Saving…" : "Update password"}
            </Button>
          </div>
        </Card>
      </form>
    </Shell>
  );
}
